/**
 *
 * v.1.0  07/04/25  Inicia
 **/

import React from 'react';
import '../../resources/css/multiselect.css';
import PropTypes from "prop-types";
import {primerElementoCodigo} from "../utils/ArrayUtils";




class MultiSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            titulosSeleccionados: [],
            codigosSeleccionados: [],
        };
        this.wrapperRef = React.createRef();
        this.codigosIniciales = props.codigosIniciales;
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
        this.calcularSeleccionadosConCodigosIniciales();
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
            this.setState({ isOpen: false });
        }
    };

    toggleDropdown = () => {
        this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
    };


    handleCheckboxChange = (opt) => {
        const {codigosSeleccionados} = this.state;
        const {onChange} = this.props;
        this.setState((prevState) => {
            const isSelected = prevState.codigosSeleccionados.includes(opt.codigo);
            const titulosSeleccionados = isSelected
                ? prevState.titulosSeleccionados.filter((item) => item !== opt.nombre)
                : [...prevState.titulosSeleccionados, opt.nombre];
            const codigosSeleccionados = isSelected
                ? prevState.codigosSeleccionados.filter((item) => item !== opt.codigo)
                : [...prevState.codigosSeleccionados, opt.codigo];

            let cadCodigosSeleccionados= codigosSeleccionados.join(",");
            onChange && onChange(cadCodigosSeleccionados);
            return { titulosSeleccionados, codigosSeleccionados };
        });
    };

    calcularSeleccionadosConCodigosIniciales= () => {
        const {options, codigosIniciales} = this.props;
        if (!codigosIniciales || codigosIniciales== "")
            return;

        let titulosSeleccionados= [];
        let codigosSeleccionados= codigosIniciales.split(",").map(Number);
        codigosSeleccionados.forEach( (codigo,index) => {
            //Buscamos el elemento:
            let elemento= primerElementoCodigo(options, codigo);
            if (elemento)
                titulosSeleccionados.push(elemento.nombre);
        });

        this.setState({codigosSeleccionados: codigosSeleccionados, titulosSeleccionados: titulosSeleccionados});
    }

    render() {
        const { isOpen, titulosSeleccionados, codigosSeleccionados } = this.state;
        const { options, label} = this.props;


        return (
            <div className={`multi-select ${isOpen ? 'open' : ''}`} onClick={this.toggleDropdown} ref={this.wrapperRef}>
                <div className="selected-labels">
                    {titulosSeleccionados.length > 0 ? titulosSeleccionados.join(', ') : label}
                </div>
                {isOpen && (
                    <div className="options" onClick={(e) => e.stopPropagation()}>
                        {options.map((opt) => (
                            <label className="option" key={opt.codigo}>
                                <input
                                    type="checkbox"
                                    value={opt.codigo}
                                    checked={codigosSeleccionados.includes(opt.codigo)}
                                    onChange={() => this.handleCheckboxChange(opt)}
                                />
                                {opt.nombre}
                            </label>
                        ))}
                    </div>
                )}
            </div>
        );
    }
}

MultiSelect.propTypes = {
    options: PropTypes.array,
    label: PropTypes.string,
    codigosIniciales: PropTypes.string,
    onChange: PropTypes.func,

}

export default MultiSelect;



